import { createDate } from "@/utils";
import { useEffect, useState } from "react";

export interface fullCalendarType {
    title: {
        year: number;
        month: number;
    };
    calendar: {
        [key: string]: number;
    }[];
}

export const useCalendar = ({ modeLength, offSet }: { modeLength: number; offSet: number }) => {
    const [fullCalendar, setFullCalendar] = useState<fullCalendarType[]>();

    useEffect(() => {
        const calendarList: fullCalendarType[] = Array.from({ length: modeLength }, (_, index) => {
            const { currentLastDay, currentYear, currentMonth, currentFirstWeek } = createDate(index + offSet);

            const fakeCalendar = Array.from({ length: currentFirstWeek }, () => ({ date: 0 }));
            const realCalendar = Array.from({ length: currentLastDay }, (_, dayIndex) => ({ date: dayIndex + 1 }));
            const calendar = [...fakeCalendar, ...realCalendar];

            return {
                title: {
                    year: currentYear,
                    month: currentMonth,
                },
                calendar,
            };
        });

        setFullCalendar(calendarList);
    }, [modeLength, offSet]);

    return { fullCalendar, setFullCalendar };
};
